import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './shared/services/api.service';
import { URL } from './service-urls';

@Injectable({
  providedIn: 'root'
})
export class EmailserviceService {

  constructor(private api: ApiService) { }

    sendDemoRequest(formData: any): Observable<any> {
    return this.api.post(URL.ACCOUNT.EMAIL_SERVICE, formData);
  }
    sendContactMessage(contactData: any): Observable<any> {
    return this.api.post(URL.ACCOUNT.CONTACT_SERVICE, contactData);
  }
  getLandingConfig(): Observable<any> {
    return this.api.get(URL.ACCOUNT.LANDING_CONFIG);
  }
  sendSubscriptionPlan(subscriptionData: any): Observable<any> {
    return this.api.post(URL.ACCOUNT.SUBSCRIPTION_PLAN, subscriptionData);
  }
}
